import { BigSource } from 'big.js'
import { amountToWei } from '../utils/amount'
import { config } from '../config'

import * as Router from '../contracts/router'
import { STAKED_DECIMALS } from '../page_components/Staking'
import { ethers } from 'ethers'

export interface IRouterContract {
  getExchangeRate: (amount: BigSource) => Promise<string[]>
  getExchangeRateUSDC: () => Promise<string[]>
  getAmountsOut: (amount: BigSource) => Promise<string[]>
}

const { lpTokenContractAddress, wbnbContractAddress, usdcContractAddress } =
  config

const initContract = (
  provider: ethers.BrowserProvider | ethers.JsonRpcProvider,
) => {
  if (provider) {
    return new ethers.Contract(
      Router.address,
      Router.abi as ethers.InterfaceAbi,
    )
  }
}

const SINGLE_ION_WEI = '1000000000000000000'

const useRouterContract = (
  provider: ethers.BrowserProvider | ethers.JsonRpcProvider,
): IRouterContract => {
  const contract = initContract(provider)

  async function getExchangeRate(amount: BigSource) {
    const toSend = amountToWei(amount, STAKED_DECIMALS).toFixed(0)
    return await contract?.getAmountsOut(toSend, [
      lpTokenContractAddress,
      wbnbContractAddress,
    ])
  }

  const getExchangeRateUSDC = async () =>
    await contract?.getAmountsOut(SINGLE_ION_WEI, [
      lpTokenContractAddress,
      usdcContractAddress,
    ])

  async function getAmountsOut(amount: BigSource) {
    const toSend = amountToWei(amount, STAKED_DECIMALS).times(0.05).toFixed(0)

    return await contract
      ?.getAmountsOut(toSend, [lpTokenContractAddress, wbnbContractAddress])
      .catch((err: any) =>
        console.error({ err, toSend }, 'failing on getAmunts out'),
      )
  }

  return { getExchangeRate, getAmountsOut, getExchangeRateUSDC }
}

export default useRouterContract
